import {currencyFormat, dateFormat, translate} from '../../utils';

export function DepositRow({deposit, isFirst, isLast, isSelected, isInvoiced, onClick}) {
    return <tr className={`deposit select ${isFirst ? 'first' : ''} ${isLast ? 'last' : ''} ${isSelected ? 'selected' : ''} ${isInvoiced ? 'danger' : ''}`} onClick={onClick}>
        <td/>
        <td className="text-danger no-br">{translate('frontend', 'DEPOSIT')}</td>
        <td className="text-danger no-br">{dateFormat(deposit.date)}</td>
        <td colSpan={3} className="text-danger text-right no-br">{currencyFormat(deposit.amount)}</td>
    </tr>;
}
